import { LayoutChangeEvent, TouchableOpacity } from 'react-native';

import { CloseTooltipIcon } from '@/assets/icons/CloseTooltipIcon';
import { TooltipArrow } from '@/assets/icons/tooltipArrow';
import { ds } from '@/components/lib/design.system';

import { Text } from './TextComponent';
import { Column, Row } from './lib/components';

type Props = {
    text: string;
    onClose: () => {};
    onLayout: (ev: LayoutChangeEvent) => void;
    closeTooltipTestId?: string;
};

/**
 * Small "callout" style tooltip showing a message and a close icon
 */
export const CalloutTooltip = ({ text, onClose, onLayout, closeTooltipTestId }: Props) => {
    return (
        <Column alignItems={'center'} onLayout={onLayout}>
            <Row
                padding={'s16'}
                gap={'s16'}
                backgroundColor={ds.colorToken.background.brand.strong}
                borderRadius={'r16'}
                alignItems={'center'}
            >
                <Text variant={'bodySmall'} color={ds.colorToken.text.primary}>
                    {text}
                </Text>
                <TouchableOpacity hitSlop={16} onPress={onClose} testID={closeTooltipTestId}>
                    <CloseTooltipIcon />
                </TouchableOpacity>
            </Row>
            <TooltipArrow />
        </Column>
    );
};
